import app from 'flarum/forum/app';
import SearchManager from 'flarum/common/SearchManager';
import Search from 'flarum/forum/components/Search';
app.initializers.add('gitzaai-cnsearch-forum', () => {
  if (SearchManager && 'MIN_SEARCH_LEN' in SearchManager) {
    SearchManager.MIN_SEARCH_LEN = 1;
  }
  if (Search && 'MIN_SEARCH_LEN' in Search) {
    Search.MIN_SEARCH_LEN = 1;
  }
});